<div class="checkout-stepper">


	<div class="content-columns">
		<div class="main-column">
			<section class="panel main-panel" [class.collapsed]="currentStep!==1">
				<div class="panel-header"><!--(click)="goToStep(1)"-->
					<div class="header-left">
						<div class="header-title">
							<span class="step-badge-large">1</span>
							<h5 class="step-badge-text">Shipping Details</h5>
						</div>
						<p class="hint">Please fill in your shipping information and then click Continue.</p>
					</div>
					<div class="header-right">
						<button type="button" class="edit-button" [disabled]="!shippingSubmitted"
							(click)="editShipping($event)">Edit</button>
						<!-- <button class="toggle" (click)="togglePanel($event,1)" aria-label="Toggle Shipping Details">
							<cx-icon class="cx-icon fas fa-angle-right flip-at-rtl chev" [class.open]="currentStep===1"></cx-icon>
						</button> -->
					</div>
				</div>

				<div class="panel-body">
					<div class="form-area">
						<knbr-shipping-details #shippingDetails></knbr-shipping-details>

						<div class="actions bottom-actions continue-btn">
							<button class="btn btn-primary" type="button" [disabled]="shippingDetails.shippingForm.invalid"
								(click)="submitShippingDetails()">Continue</button>
						</div>
					</div>
				</div>
			</section>

			<section class="panel review-panel" [class.collapsed]="currentStep!==2">
				<div class="panel-header"><!--(click)="goToStep(2)"-->
					<div class="header-left">
						<div class="header-title">
							<span class="step-badge-large">2</span>
							<h5 class="step-badge-text">Review Order</h5>
						</div>
					</div>
					<div class="header-right">
						<!-- <button class="toggle" (click)="togglePanel($event,2)" aria-label="Toggle Review Order">
							<cx-icon class="cx-icon fas fa-angle-right flip-at-rtl chev" [class.open]="currentStep===2"></cx-icon>
						</button> -->
					</div>
				</div>

				<div class="panel-body">
					<knbr-review-order></knbr-review-order>
					<!-- <div class="actions">
						<button type="button" class="btn btn-primary" (click)="previous()">Back</button>
					</div> -->
				</div>
			</section>
		</div>

		<aside class="sidebar">
			<label>PO/Job Number <span class="optional">(optional)</span>
				<input type="text" [(ngModel)]="poNumber" name="poNumber" placeholder="Enter PO or Job Number" (input)="onPoNumberInput($event)">
			</label>

			<div class="place-order">
				<button class="btn btn-primary" (click)="placeOrder()" [disabled]="!canPlaceOrder">Place Order</button>
			</div>
			@if(canPlaceOrder){
			<div class="email-info-section mt-1">
				<p class="p-0 m-0">By placing your order, you agree to recive order confirmation and updates via email</p>
				<p class="p-0 m-0"><b>{{orderemail}}</b></p>
			</div>
		}
		</aside>
	</div>
</div>
